import {
  Button,
  Col,
  Input,
  Row,
  Space,
  Switch,
  Table,
} from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import { withTranslation } from "react-i18next";
import {
  SearchOutlined,
} from "@ant-design/icons";
import ImageUploader from "quill-image-uploader";
import ImageResize from "@apoiase/quill-image-resize";
import { message_types } from "../../constants/message-event-types";
import {
  getCardForEntryPoint
} from "../../actions/entrypoints";
import moment from "moment";

Quill.register("modules/imageUploader", ImageUploader);
Quill.register("modules/imageResize", ImageResize);

const mapDispatchToProps = (dispatch) => {
  return {
    getCardForEntryPoint: (entrypointDeviceId) => dispatch(getCardForEntryPoint(entrypointDeviceId)),
  };
};


class ConnectedSynchronizationEndpointCheck extends Component {
  formRef = React.createRef();

  state = {
    content: "",
    title: "",
    modify: false,
    selectedId: null,
    showDetails: false,
    text: "",
    active: true,
    mode: message_types.immediate,
    entryPointDeviceId: '',
    filteredInfo: {},
  };

  componentDidMount = async () => {
   
  };

  checkEntryPointSynchonization = () => {
    this.props.getCardForEntryPoint(this.state.entryPointDeviceId);
  };

  handleModify = (record) => {
    this.setState({
      modify: true,
      title: record.title,
      content: record.content,
      text: record.text,
      selectedId: record.id,
      selectedCompany: record.companyId,
      newMessageVisible: true,
      date: new Date(record.date),
      mode: record.mode,
    });
    this.formRef.current.setFieldsValue({
      title: record.title,
      content: record.content,
      date: moment(new Date(record.date)),
      mode: record.mode,
    });
  };

  handleCancelModify = () => {
    this.setState({
      modify: false,
      title: "",
      content: "",
      text: "",
      selectedId: null,
      selectedCompany: null,
      newMessageVisible: false,
      mode: message_types.immediate,
    });
    this.formRef.current.resetFields();
  };

  handleShowDetails = (record) => {
    this.setState({ showDetails: true, selectedMessage: record });
  };

  handleCloseDetails = () => {
    this.setState({ showDetails: false, selectedMessage: {} });
  };

  handleTextInputChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };
  
  resetFilter = () => {
    this.setState({
      filteredInfo: {},
      searchedColumn: null,
      searchText: "",
      filterKey: null,
    });
  };

  handleChangeTable = (pagination, filters, sorter) => {
    this.setState({
      filteredInfo: filters,
      sortedInfo: sorter,
    });
  };

  render() {
      const columns = [
      {
        title: "id",
        dataIndex: "id",
        key: "id",
        sorter: (a, b) => a.title.id(b.id),
        sortDirections: ["ascend", "descend"],
      },
      {
        title: "rfidString",
        key: "rfidString",
        sorter: (a, b) => {
          const rfidStringA = `${a?.rfidString}`;
          const rfidStringB = `${b?.rfidString}`;

          return rfidStringA.localeCompare(rfidStringB);
        },
        sortDirections: ["ascend", "descend"],
        render: (text, record) => {
          return (
            <Space size="middle">
              {record.rfidString}
            </Space>
          );
        },
      },
      {
        title: "email",
        key: "email",
        sorter: (a, b) => {
          return a.email.localeCompare(b.email);
        },
        sortDirections: ["ascend", "descend"],
        render: (text, record) => {
          return (
            <Space size="middle">
              {record.email}
            </Space>
          );
        },
      },
      {
        title: this.props.t("activate-button-label"),
        key: "activate",
        render: (text, record) => {
          return (
            <Space size="middle">
              <Switch
                checked={record.active}
                onChange={(event) => {}}
              />
            </Space>
          );
        },
      },
      {
        title: "userId",
        key: "userId",
        sorter: (a, b) => {
          return a.userId.localeCompare(b.userId);
        },
        sortDirections: ["ascend", "descend"],
        render: (text, record) => {
          return (
            <Space size="middle">
              {record.userId}
            </Space>
          );
        },
      },
      {
        title: "activationTime",
        key: "activationTime",
        sorter: (a, b) => {
          const createdA = new Date(a.activationTime).toISOString();
          const createdB = new Date(b.activationTime).toISOString();

          return createdA.localeCompare(createdB);
        },
        sortDirections: ["ascend", "descend"],
        render: (text, record) => {
          return (
            <Space size="middle">
              {record.activationTime ? new Date(record.activationTime).toLocaleString() : ''}
            </Space>
          );
        },
      },
    ];
    return (
      <div style={{ height: "100%" }}>
        <Row>
          <Col span={24}>
            <h1 style={{ fontSize: "2rem", color: "#00A49A" }}>
              <strong>Szinkronizáció ellenőrzése</strong>
            </h1>
          </Col>
        </Row>
        <Row>
          <Col span={12} style={{ padding: "1em" }}>
            <Input
              name="entryPointDeviceId"
              onChange={this.handleTextInputChange}
              value={this.state.entryPointDeviceId}
            />
          </Col>
          <Col span={12} style={{ padding: "1em" }}>
            <Button
              onClick={this.checkEntryPointSynchonization}
              type="primary"
              style={{ float: "right" }}
            >
              <SearchOutlined /> Ellenőrzés
            </Button>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Table
              rowKey="id"
              columns={columns}
              dataSource={this.props.synchronizationData}
              pagination={{
                position: ["bottomCenter"],
                showSizeChanger: true,
              }}
              onChange={this.handleChangeTable}
              locale={{ emptyText: this.props.t("empty-text") }}
            />
          </Col>
        </Row>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  synchronizationData: state.entrypointReducer.synchronizationData
});
const SynchronizationEndpointCheck = withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(ConnectedSynchronizationEndpointCheck)
);
export default SynchronizationEndpointCheck;
